import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { paidGuides } from "@/mocks/guides";

const freeVsPaid = [
  {
    label: "無料記事",
    items: [
      "制度の基本（仕組み・流れ・用語）",
      "公式情報へのリンクと確認日の記録",
      "誰でも読める一般公開の内容",
    ],
    className: "border-background-200 bg-background-50",
    badgeClassName: "bg-primary-100 text-primary-800",
    icon: "ri-book-open-line",
  },
  {
    label: "有料PDFガイド（準備中）",
    items: [
      "運営者の実体験にもとづく手順と記録",
      "オリジナルのチェックリスト・テンプレート",
      "独自に作成した練習問題と学習スケジュール",
    ],
    className: "border-accent-200 bg-accent-50",
    badgeClassName: "bg-accent-100 text-accent-800",
    icon: "ri-lock-line",
  },
];

export default function GuidesIndex() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <section className="w-full border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-20">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-accent-700">
              <span className="h-[1px] w-6 bg-accent-500" />
              Paid Guides
            </p>
            <h1 className="mt-4 font-heading text-[28px] font-bold leading-[1.5] tracking-tight text-foreground-950 md:text-[38px]">
              詳しく学ぶ・有料ガイド
            </h1>
            <p className="mt-5 max-w-2xl text-[13.5px] leading-[2] text-foreground-700 md:text-[14.5px]">
              無料記事より一歩踏み込んだ、実体験ベースのPDFガイドを準備しています。現在はすべて制作中のため、購入はできません。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-4 py-1.5 text-[11.5px] font-semibold text-accent-800">
              <i className="ri-time-line text-[13px]" />
              3冊すべて準備中・購入ボタンは無効です
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-16">
            <div className="grid gap-5 md:gap-6 lg:grid-cols-2">
              {freeVsPaid.map((column) => (
                <div key={column.label} className={`rounded-[10px] border p-6 md:p-7 ${column.className}`}>
                  <p className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold ${column.badgeClassName}`}>
                    <i className={`${column.icon} text-[12px]`} />
                    {column.label}
                  </p>
                  <ul className="mt-4 space-y-2.5">
                    {column.items.map((item) => (
                      <li
                        key={item}
                        className="flex items-start gap-2 text-[12.5px] leading-[1.9] text-foreground-700"
                      >
                        <i className="ri-check-line mt-[4px] shrink-0 text-[14px] text-foreground-500" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="mt-12 grid gap-5 md:gap-6 lg:grid-cols-3">
              {paidGuides.map((guide, index) => (
                <Reveal key={guide.slug} as="article" delay={index * 70} className="h-full">
                  <div className="flex h-full flex-col rounded-[10px] border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-[3px] hover:border-accent-200 hover:shadow-[0_20px_36px_-26px_rgba(23,37,35,0.45)] md:p-7">
                  <div className="flex items-start justify-between gap-3">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-50 text-accent-600">
                      <i className={`${guide.icon} text-[22px]`} />
                    </span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-2.5 py-1 text-[10.5px] font-semibold text-foreground-600">
                      <i className="ri-time-line text-[11px]" />
                      準備中
                    </span>
                  </div>
                  <p className="mt-5 font-heading text-[11px] font-bold tracking-[0.14em] text-accent-600">
                    GUIDE {guide.number}
                  </p>
                  <h2 className="mt-2 font-heading text-[17px] font-bold leading-[1.6] text-foreground-950">
                    {guide.title}
                  </h2>
                  <p className="mt-2.5 text-[12.5px] leading-[1.9] text-foreground-600">
                    {guide.summary}
                  </p>

                  <ul className="mt-4 flex-1 space-y-2">
                    {guide.contents.slice(0, 4).map((item) => (
                      <li
                        key={item}
                        className="flex items-start gap-2 text-[12px] leading-[1.85] text-foreground-700"
                      >
                        <i className="ri-check-line mt-[4px] shrink-0 text-[13px] text-accent-500" />
                        {item}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-5 border-t border-background-200 pt-4">
                    <p className="text-[11.5px] text-foreground-500">価格：未定（完成時に案内します）</p>
                    <button
                      type="button"
                      disabled
                      className="mt-3 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-5 py-2.5 text-[12.5px] font-semibold text-foreground-400"
                    >
                      <i className="ri-lock-line text-[13px]" />
                      準備中のため購入できません
                    </button>
                    <Link
                      to={`/guides/${guide.slug}`}
                      className="mt-3 inline-flex w-full items-center justify-center gap-1.5 rounded-full px-5 py-2 text-[12px] font-semibold text-primary-700 transition-colors hover:text-primary-800"
                    >
                      内容を見る
                      <i className="ri-arrow-right-line text-[13px]" />
                    </Link>
                  </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <div className="mt-10 flex flex-col gap-3 rounded-[10px] border border-background-200 bg-background-100 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-[12px] leading-[1.9] text-foreground-600">
                まずは無料記事で制度の基本を確認したい方はこちら。
              </p>
              <Link
                to="/learn"
                className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-primary-700 px-5 py-2.5 text-[12.5px] font-semibold text-background-50 transition-colors hover:bg-primary-800"
              >
                無料で学ぶ
                <i className="ri-arrow-right-line text-[14px]" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}